var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-title',{staticClass:"mr-4 ml-4"},[_c('img',{staticClass:"logo-h15",attrs:{"alt":"Sony","src":require("../assets/logo-white.png")}}),_vm._v("   |   "),_c('router-link',{staticClass:"program-title text-decoration-none",attrs:{"to":{ name: 'dashboard' }}},[_vm._v(" "+_vm._s(_vm.currentProgram)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }